import {EntityApiService, ApiClientService} from '@dofleini/security';

class NomenclaturesAreaTypeApiService extends EntityApiService {

    getOneAreaType = ({areaTypeId}, params) => {
      const config = {params};
      if (params?.projections && Array.isArray(params.projections)) {
        config.params = {
          ...params,
          projections: params.projections.join(',')
        };
      }
      return ApiClientService.get(this.getPath(`/${areaTypeId}`), config);
    };
}

export default new NomenclaturesAreaTypeApiService('/ms-core/api/typeareas');
